var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionMenuActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#215054"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6875 7.3125C19.0938 7.6875 19.0938 8.34375 18.6875 8.71875L10.6875 16.7188C10.3125 17.125 9.65625 17.125 9.28125 16.7188L5.28125 12.7188C4.875 12.3438 4.875 11.6875 5.28125 11.3125C5.65625 10.9062 6.3125 10.9062 6.6875 11.3125L10 14.5938L17.2812 7.3125C17.6562 6.90625 18.3125 6.90625 18.6875 7.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionMenuActive);
export default __webpack_public_path__ + "static/media/action_menu_active.a1fe57d5192e6f4f4e2dc7f26da80201.svg";
export { ForwardRef as ReactComponent };